import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Field } from 'redux-form'
import { BodyBold } from 'ggx-componentlibrary/design/typography/typography.styles'
import {
  MerchantOrderNoteFormWrapper,
  StyledTooltip,
  StyledSmallText,
  StyledSmallTextNoWrap,
} from './merchant-order-note-form.component.styles'
import { SPACING } from 'ggx-componentlibrary/design/spacing/spacing.constants'
import { TextArea } from './text-area.component'
import BET_4311 from 'ggx-src/feat/BET_4311'

const MerchantOrderNoteForm = ({ name }) => {
  const [t] = useTranslation()
  const validator = BET_4311.useRequireMerchantOrderNoteValidator(
    useMemo(
      () => [value => (value?.length > 100 ? true : undefined)],
      []
    )
  )
  return (
    <MerchantOrderNoteFormWrapper>
      <StyledTooltip
        heading={
          <>
            <BodyBold typographyStyles="mb-none">
              {t('merchant_order_note')}
            </BodyBold>
            {
              !BET_4311.useFeatureFlagRequireMerchantOrderNote() && <StyledSmallText>{t('optional')}</StyledSmallText>
            }
          </>
        }
        noMargin
        marginBottom={SPACING.S}
        content={useMemo(
          () => (
            <StyledSmallTextNoWrap>
              {t('helpertext__merchant_order_note_searchable')}
            </StyledSmallTextNoWrap>
          ),
          []
        )}
      />

      <Field
        name={name}
        component={TextArea}
        placeholder={t('merchant_order_note__placeholder')}
        validate={validator}
        maxLength="100"
        minRows="1"
      />
    </MerchantOrderNoteFormWrapper>
  )
}

export { MerchantOrderNoteForm }
